import styled from 'styled-components';

const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  overflow: auto;
`;

const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export default { Container, ResultContainer, SpinnerContainer };
